import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Gốc server (không có /api) — dùng để dựng URL đầy đủ cho ảnh upload local (/uploads/...).
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

// Ảnh có thể là URL tuyệt đối (Supabase Storage cũ) hoặc path tương đối
// trả về từ /site-images/upload (/uploads/site-assets/...) — chuẩn hoá về URL đầy đủ.
export function resolveAssetUrl(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_ORIGIN}${url.startsWith('/') ? '' : '/'}${url}`;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Request interceptor: Gắn token nếu có trong localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ttp_admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Xử lý lỗi tập trung
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Lỗi kết nối máy chủ';
    return Promise.reject(new Error(message));
  }
);

export default api;
